<style lang="scss">
  .small-table {
    .ls-admin-table-block {
      margin-top: -15px;
      padding-top: 0;
    }
  }
  .ls-admin-table-block {
    width: 100%;
    margin-top: 15px;
    padding: 15px;
    background: #fff;
    box-sizing: border-box;

    .ls-admin-form {
      margin: 10px;
    }

    th,
    td {
      padding: 3px 0 !important;
    }

    .el-pagination {
      padding-top: 15px;
    }

    .el-row {
      margin-bottom: 15px;
    }

    .el-button--mini {
      padding: 5px 10px;
    }

    .el-input__inner {
      height: 20px;
      padding: 0 5px;
      line-height: 20px;
      font-size: 12px;
    }

    .el-date-editor {
      width: 150px;

      .el-input__inner {
        padding-left: 30px;
      }
    }

    .el-radio__label {
      display: none;
    }

    .el-table__footer td {
      color: red;
    }
  }

  .ls-admin-table {
    &__head {
      th {
        color: rgb(77, 77, 77);
        background-color: #f5f7fa !important;
      }
    }
  }
</style>

<template>
  <div class="ls-admin-table-block flex flex-column" v-if="loaded">
    <slot></slot>
    <div v-if="!isHideBtns" class="flex" style="padding-bottom:15px">
      <div class="flex-item">
        <slot name="left"></slot>
      </div>
      <div style="text-align:right">
        <slot name="right"></slot>
        <el-button size="mini" v-if="columnKey" icon="el-icon-s-tools" class="btn-blue" @click="editColumn">编辑列
        </el-button>
      </div>
    </div>

    <el-table ref="datatable" :data="data" class="ls-admin-table flex-item" header-row-class-name="ls-admin-table__head" size="mini"
              stripe border :height="height" :show-summary="!!summaryMethod" :summary-method="summaryMethod"
              :resizable="true" @sort-change="sort" v-loading="loading" :highlight-current-row="isShowSingleChecked"
              @selection-change="handleSelectionChange" @current-change="handleCurrentChange"
              @row-dblclick="handleRowDbclickChange" @row-click="handleRowClickChange" @select="handleSelect">
      <el-table-column fixed v-if="expand" :row-key="-3" type="expand">
        <template slot-scope="props">
          <slot name="expand" :props="props"></slot>
        </template>
      </el-table-column>
      <el-table-column fixed v-if="!hideSerial" :sortable="hideOrder ? false : 'custom'" :row-key="-2"
                       type="index" min-width="55" label="序号"></el-table-column>
      <el-table-column fixed v-if="!hideMultiple" :row-key="-1" type="selection" min-width="40"></el-table-column>
      <el-table-column v-for="(item, index) in list" :key="index" :prop="item.name" :label="item.value"
                       :min-width="item.width"
                       :show-overflow-tooltip="true" :row-key="index" :align="item.align ? item.align : 'left'"
                       :fixed="item.fixed || false" :sortable="(hideOrder || item.hideOrder) ? false : 'custom'">
        <template slot-scope="props">
          <el-popover placement="left" width="200" trigger="hover" v-if="item.type === CONSTANT.columnType.IMG">
            <el-image :src="props.row[item.name]"></el-image>
            <el-link v-show="props.row[item.name]" slot="reference" type="primary" :underline="false"
                     target="_blank" :href="props.row[item.name]">查看图片
            </el-link>
            <!--<span v-show="!props.row[item.name]" slot="reference" style="font-size: 11px">暂无图片</span>-->
          </el-popover>
          <el-link v-else-if="item.type === CONSTANT.columnType.FILE" icon="el-icon-download" type="primary"
                   v-show="props.row[item.name]" :underline="false" target="_blank" :href="props.row[item.name]">下载
          </el-link>
          <el-link v-else-if="item.type === CONSTANT.columnType.LINK" icon="el-icon-view" type="primary"
                   v-show="props.row[item.name]" :underline="false" target="_blank" :href="props.row[item.name]">查看
          </el-link>
          <el-button v-else-if="item.type === CONSTANT.columnType.PREVIEW" type="text"
                     v-show="props.row[item.name]"
                     icon="el-icon-view" size="mini" @click="previewShow(props.row[item.name])">查看</el-button>
          <el-button v-else-if="item.type === CONSTANT.columnType.BTN" type="text" size="mini"
                     @click="item.func(props.row)">{{item.txt}}</el-button>
          <slot :name="'slot_' + item.name" :props="props" v-else>
            {{item.filter ? item.filter(props.row, props.column.property) : props.row[item.name]}}
          </slot>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="!hidePage" :current-page.sync="pageParam.page.current" :page-sizes="pageSizes"
                   :page-size="pageParam.page.size" :layout="pageLayout" :total="pageParam.total"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>

    <ls-admin-dialog title="编辑列" :show.sync="columnParam.isShow" width="400px" @save="saveCloumn">
      <el-checkbox :indeterminate="columnParam.isIndeterminate" v-model="columnParam.checkAll"
                   @change="handleCheckAllChange">全选
      </el-checkbox>
      <el-row>
        <el-checkbox-group v-model="columnParam.checkedColumns" @change="handleCheckedColumnsChange">
          <el-col v-for="item in columnParam.all" :key="item" :span="8">
            <el-checkbox :label="item" :key="item"></el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-row>
    </ls-admin-dialog>

    <!--预览弹窗-->
  </div>
</template>

<script>
  import help from '@/util/help';
  import adminHelp from '@/util/adminHelp';
  import CONSTANT from '@/util/const';

  export default {
    props: {
      // 列筛选
      columnKey: {
        type: String
      },
      // 统计方法
      summaryMethod: {
        type: Function
      },
      // 列表是否在加载中
      loading: {
        type: Boolean,
        default: false
      },
      // 表高度
      height: {
        type: Number,
        default: 250,
      },
      // 是否隐藏按钮行
      isHideBtns: {
        type: Boolean,
        default: false
      },
      expand: {
        type: Boolean,
        default: false,
      },
      // 是否显示el-table的单选
      isShowSingleChecked: {
        type: Boolean,
        default: false
      },
      // 是否隐藏序列
      hideSerial: {
        type: Boolean,
        default: false
      },
      // 是否隐藏排序
      hideOrder: {
        type: Boolean,
        default: false
      },
      // 是否隐藏分页
      hidePage: {
        type: Boolean,
        default: false
      },
      // 是否隐藏多选列
      hideMultiple: {
        type: Boolean,
        default: false
      },
      // 列的表头
      columns: {
        type: Array,
        default: () => {
          return []
        }
      },
      // 表数据
      data: {
        type: Array,
        default: () => {
          return []
        }
      },
      // 页码的显示样式
      pageLayout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper'
      },
      pageSizes: {
        type: Array,
        default: () => {
          return [10, 20, 50]
        }
      },
      // 页码的相关参数
      pageParam: {
        type: Object,
        default: () => {
          return {
                "page": {
                "current": 1,
                "size": 10,
                "total": 0,
              },
              "model": {

              }
          }
        }
      }
    },
    data() {
      return {
        CONSTANT,
        loaded: false,
        selections: [],
        radio: '',
        columnParam: {
          all: [],
          isShow: false,
          checked: false,
          isIndeterminate: true,
          checkedColumns: []
        },
        preview: adminHelp.getDialog('', {
          content: '',
        }),
      }
    },
    computed: {
      list() {
        return (
          this.columns && this.columns.filter(item => !item.isHide && !item.isDel)
        )
      }
    },
    created() {
      if (this.columnKey) {
        this.columnParam.all = this.columns.map(item => item.value)
        this.columnParam.checkedColumns =
          help.getLocal(this.columnKey) || this.columns.map(item => item.value)
        this.computedCloumn()
      }
    },
    mounted() {
      this.loaded = true
    },
    methods: {
      handleRowDbclickChange(row) {
        this.$emit('handleRowDbclickChange', row)
      },

      handleRowClickChange(row) {
        if (this.isExpand) {
          this.$refs.table.toggleRowExpansion(row);
        }
        if (this.isSelection && !this.stopSelection) {
          this.$refs.datatable.clearSelection()
          this.$refs.datatable.toggleRowSelection(row, true)
          this.$emit('handleRowClickChange', row)
        }

      },
      sort(row) {
        this.$emit('sort', row)
      },
      handleSelectionChange(val) {
        this.selections = val
      },
      handleSizeChange(val) {
        this.$emit('handleSizeChange', val)
      },
      handleCurrentChange(val) {
        this.$emit('handleCurrentChange', val)
      },
      handleSelect(selection, row) {
        this.$emit('handleSelect', selection, row)
      },

      // 预览弹窗按钮
      previewShow(content) {
        adminHelp.showDialog(this.preview, {
          content,
        })
      },

      computedCloumn() {
        for (let i = 0; i < this.columnParam.all.length; i++) {
          var item = this.columns[i]
          item.isHide = true
          this.$set(this.columns, i, item)
          for (let j = 0; j < this.columnParam.checkedColumns.length; j++) {
            if (this.columnParam.all[i] === this.columnParam.checkedColumns[j]) {
              this.columns[i].isHide = false
              break
            }
          }
        }
      },
      editColumn() {
        this.columnParam.checkedColumns =
          help.getLocal(this.columnKey) || this.columns.map(item => item.value)
        this.columnParam.isShow = true
      },
      handleCheckAllChange(val) {
        this.columnParam.checkedColumns = val
          ? this.columns.map(item => item.value)
          : []
        this.columnParam.isIndeterminate = false
      },
      handleCheckedColumnsChange(value) {
        let checkedCount = value.length
        this.columnParam.checkAll = checkedCount === this.columns.length
        this.columnParam.isIndeterminate =
          checkedCount > 0 && checkedCount < this.columns.length
      },
      saveCloumn() {
        help.setLocal(this.columnKey, this.columnParam.checkedColumns)
        this.computedCloumn()
        this.columnParam.isShow = false
      }
    },
    components: {}
  }
</script>
